<template>
  <div class="main">
    <!--
      ================================================== HEADING ==================================================
     -->
    <div class="head d-flex flex-column flex-md-row justify-content-between px-2 mt-2">
      <span
        v-if="contextBarcode.barcodeStatus !== 'Reports Ready'"
        class="heading text-primary"
      > {{ contextKitUser.firstname[contextKitUser.firstname.length - 1] == 's' ? contextKitUser.firstname+"'": contextKitUser.firstname + "'s" }} Health Journey </span>
      <span
        v-else
        class="heading text-primary"
      > An Introduction to Your Reports</span>
      <div>
        <div
          v-if="contextBarcode.questionnaireStatus !== 'Survey Completed' || ((contextKitUser.address.country === 'India' && contextBarcode.kitPickupStatus === 'Not Scheduled' && kitPickupEnabled) || (contextKitUser.address.country !== 'India' && contextBarcode.kitPickupStatus !== 'Received' && !scheduleDone && contextBarcode.userConfirmedKitPickup === false))"
          id="your-next-action"
          class="mt-2 mt-md-0"
        >
          <span class="mr-1">Your next action: </span>
          <b-button
            v-if="contextBarcode.questionnaireStatus !== 'Survey Completed'"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            @click="$router.push('questionnaire/' + contextBarcode.questionnaireResponses.mandatory)"
          >
            Complete Survey
          </b-button>
          <b-button
            v-else-if="(contextKitUser.address.country === 'India' && contextBarcode.kitPickupStatus === 'Not Scheduled' && kitPickupEnabled) || (contextKitUser.address.country !== 'India' && contextBarcode.kitPickupStatus !== 'Received')"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            @click="showKitpickupModal"
          >
            Send us your samples
          </b-button>
        </div>
      </div>
    </div>
    <b-row class="w-100 mx-0">
      <b-col
        v-if="contextBarcode.barcodeStatus === 'Reports Ready'"
        class="px-2 mt-1"
      >
        <KitUserSelector
          class="d-md-none"
          style="background: white;"
        />
      </b-col>
      <b-col
        v-if="mandatoryQuestionnaireData"
        :key="contextBarcodeId"
        cols="12"
        class="px-2 my-1"
      >
        <!-- timeline card -->
        <TimelineCard
          v-if="contextBarcode.barcodeStatus !== 'Reports Ready' && contextBarcode.kitType === 'kid' "
          :questionnaire-data="mandatoryQuestionnaireData"
          :timeline="kidTimeline"
        />
        <TimelineCard
          v-if="contextBarcode.barcodeStatus !== 'Reports Ready' && contextBarcode.kitType === 'adult' "
          :questionnaire-data="mandatoryQuestionnaireData"
          :timeline="adultTimeline"
        />
        <TimelineCard
          v-if="contextBarcode.barcodeStatus !== 'Reports Ready' && contextBarcode.kitType === 'covid'"
          :questionnaire-data="mandatoryQuestionnaireData"
          :timeline="covidTimeline"
        />
        <TimelineCard
          v-if="contextBarcode.barcodeStatus !== 'Reports Ready' && contextBarcode.kitType === 'longevity' "
          :questionnaire-data="mandatoryQuestionnaireData"
          :timeline="longevityTimeline"
        />
      </b-col>
      <b-col
        cols="12"
        class="px-2"
      >
        <FollowupCard v-if="showFollowUp && contextBarcode.barcodeStatus === 'Reports Ready'" />
      </b-col>
      <b-col
        v-if="contextBarcode.kitPickupStatus === 'Received'"
        cols="12"
        class="p-0 mt-2"
      >
        <IntroductionSections />
      </b-col>
      <b-col
        v-if="(contextKitUser.address.country === 'India' && contextBarcode.kitPickupStatus === 'Scheduled')"
        class="mt-2"
      >
        <ScienceCard />
      </b-col>
      <b-col
        v-if="
          mandatoryQuestionnaireData &&
            mandatoryQuestionnaireData.status !== 'Complete'
        "
        :cols="colSpan"
        class="px-2 my-2"
      >
        <!-- Questionnaire Card -->
        <div
          class="mandatory-questionnaire-card d-flex flex-column justify-content-between h-100 "
        >
          <div class="d-flex justify-content-between ">

            <div
              cols="10"
              class="pr-5 py-2 pl-2"
            >
              <div
                v-if="contextBarcode.kitType === 'kid' || contextBarcode.kitType === 'adult' || contextBarcode.kitType === 'longevity'"
                class="title font-weight-normal text-black mb-1"
              >
                What do your lifestyle choices say about your health?
              </div>
              <div
                v-else
                class="title font-weight-normal text-black mb-1"
              >
                What do your symptoms say about your post covid recovery?
              </div>
              <p class="questions-pending-status mb-2 mb-lg-3">
                <span
                  class="d-block status-count"
                >{{ progressString }}
                  questions completed</span>
                Please complete this survey!
              </p>
              <hover-button
                title="Complete"
                color="primary-white"
                @click="
                  $router.push('questionnaire/' + mandatoryQuestionnaireData._id)
                "
              />
            </div>
            <div class="align-self-end">
              <img
                class="covid-product-img"
                src="../../assets/images/dashboard-mandatory-questionnaire.png"
                alt="product image"
              >
            </div>
          </div>
        </div>
      </b-col>
      <!-- Covid report Card -->
      <!-- <b-col
        v-if="
          contextBarcode.kitType == 'covid' &&
            nutritionPlanBool &&
            contextBarcode.barcodeStatus !== 'Reports Ready'
        "
        :cols="colSpan"
        class="px-2 px-md-1 mt-2"
      >
        <div
          class="covid-default-report-card d-flex flex-column justify-content-between h-100"
        >
          <div class="d-flex justify-content-between">
            <div class="title font-weight-normal text-black">
              Your Starter Nutrition Plan is here!
            </div>
            <img
              src="@/assets/images/salad@2x.png"
              alt=""
            >
          </div>
          <div
            class="d-flex subtitle justify-content-between align-items-start align-items-lg-center flex-column flex-lg-row"
          >
            <p class="questions-pending-status w-75">
              <span
                class="d-block status-count"
              >
                Manage post-COVID symptoms with personalized food lists, diet charts and recipes, recommended for the first phase of your personal recovery.
              </span></p>
            <hover-button
              title="Download"
              color="primary-dark"
              class="mt-1 mt-lg-0"
              @click="download"
            />
          </div>
        </div>
      </b-col> -->

      <b-col
        v-if="(contextKitUser.address.country === 'India' && contextBarcode.kitPickupStatus !== 'Scheduled' && contextBarcode.kitPickupStatus !== 'Received') || (contextKitUser.address.country !== 'India' && contextBarcode.kitPickupStatus === 'Scheduled')"
        :cols="colSpan"
        class="px-2 my-2"
      >
        <!-- PDF Guide Card -->
        <div
          class="pdf-guide-card d-flex flex-column flex-md-row h-100"
        >
          <div class="d-flex justify-content-between align-items-start">
            <div
              class="p-2 h-100 d-flex flex-column align-items-stretch justify-content-between"
            >
              <div class="mb-1 d-flex flex-column">
                <div class="title mb-1">
                  Learn how to use your new kit effectively
                </div>
                <p class="subtitle mb-1 align-self-start">
                  Follow our step by step guide
                </p>
              </div>
              <hover-button
                title="View"
                color="primary-white"
                @click="openGuidePdf"
              />
            </div>
          </div>
          <img
            v-if="contextBarcode.haveDNAData && contextBarcode.duBarcode !== ''"
            :src="breakpoint === 'xs' || breakpoint === 'sm' ? require('@/assets/images/NH_DU_kit.png') : require('@/assets/images/Navipoint-Dual-kit.png')"
            alt="product image"
            :class="breakpoint === 'md'|| breakpoint === 'lg' || breakpoint === 'xl' ? 'learn-more-image' : ''"
            :style=" breakpoint === 'md'|| breakpoint === 'lg' || breakpoint === 'xl' ? '' : 'border-radius: 0px 0px 10px 10px'"
          >
          <img
            v-else-if="contextBarcode.haveDNAData"
            :src="breakpoint === 'xs' || breakpoint === 'sm' ? require('@/assets/images/NH_SA_kit.png') : require('@/assets/images/SA_kit.png')"
            :class="breakpoint === 'md'|| breakpoint === 'lg' || breakpoint === 'xl' ? 'learn-more-image' : ''"
            :style=" breakpoint === 'md'|| breakpoint === 'lg' || breakpoint === 'xl' ? '' : 'border-radius: 0px 0px 10px 10px'"
            alt="product image"
          >
          <img
            v-else
            :src="breakpoint === 'xs' || breakpoint === 'sm' ? require('@/assets/images/NH_ST_kit.png') : require('@/assets/images/Microbiome-Testing-kit.jpg')"
            alt="product image"
            :class="breakpoint === 'md'|| breakpoint === 'lg' || breakpoint === 'xl' ? 'learn-more-image' : ''"
            :style=" breakpoint === 'md'|| breakpoint === 'lg' || breakpoint === 'xl' ? '' : 'border-radius: 0px 0px 10px 10px'"
          >

        </div>
      </b-col>
      <!-- Fact Card -->
      <b-col
        v-if=" contextBarcode.kitPickupStatus !== 'Received'"
        :md="mandatoryQuestionnaireData &&
          mandatoryQuestionnaireData.status !== 'Complete'? 12 : 6"
        class="px-2 my-2"
      >
        <FactCard />
      </b-col>
    </b-row>
    <b-modal
      v-if="contextKitUser.address.country === 'India'"
      ref="schedule-pickup"
      hide-footer
      hide-header
      centered
      :no-close-on-backdrop="!canCloseThankYouPickupPopup"
      @hide="fetchUsersOnClose"
    >
      <validation-observer ref="kitPickupForm">
        <div
          v-if="!scheduleDone"
          class="form"
        >
          <header>
            <img
              src="@/assets/images/icons/close-icon.svg"
              alt=""
              class="modal-close-btn mt-1"
              @click="hide"
            >
          </header>
          <h1 class="mb-1">
            Request a sample pick-up
          </h1>
          <p class="mb-2">
            We will contact you to schedule a pickup soon.<br>
            <b>Please note that pickup services will be scheduled only on
              weekdays (Mon - Fri)</b>
          </p>
          <p class="mb-2">
            Please confirm your pick-up details below.
          </p>
          <div
            class="addressAndDateContainer"
          >
            <p
              v-if="!phone"
              class="text-danger"
            >
              Add your phone number for proceeding with kit pickup.
            </p>
            <b-row class="px-1">
              <b-col
                class="mb-1 px-0 col-md-2"
                cols="3"
              >
                <validation-provider
                  #default="{ errors }"
                  mode="lazy"
                  name="countryPhoneCode"
                  rules="required"
                  :custom-messages="{
                    required: 'Please select your country code',
                  }"
                >
                  <v-select
                    id="phoneCode"
                    v-model="countryPhoneCode"
                    placeholder="Country Code"
                    autocomplete
                    :options="countries"
                    label="phonecode"
                    :reduce="country => country.phonecode"
                    class="input-fill h-80 "
                    :class="{'onerror':errors.length>0}"
                    :components="{Deselect}"
                  ><template
                    v-slot:option="option"
                  >
                    {{ option.isoCode }} ({{ option.phonecode }})
                  </template>
                  </v-select>

                </validation-provider>
              </b-col>
              <b-col class="px-0">
                <validation-provider
                  #default="{ errors }"
                  name="phone"
                  :rules="{ required: true, regex: countryPhoneCode === '+91' || countryPhoneCode === '+1' ? /^[0-9]{10}$/ : /^\d{9,14}$/ }"
                  mode="lazy"
                >
                  <b-form-input
                    id="phone"
                    v-model="phone"
                    placeholder="Phone number"
                    class="mb-1 input-fill"
                    type="text"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
          </div>
          <div class="addressAndDateContainer">
            <b-col
              class="p-2 mb-2 gray-background"
              cols="12"
            >
              <div class="d-flex justify-content-between">
                <h4 class="d-flex align-items-end">
                  {{ user.firstName + " " + user.lastName }}
                </h4>
                <b-button
                  class="d-flex align-items-center justify-content-center"
                  variant="link"
                  @click="toggleEditDetailsForm"
                >
                  Edit Details
                </b-button>
              </div>
              <p class="text-left mt-2">
                {{ user.address.street
                }},{{ user.address.street1 }}<br>
                {{ user.address.city }},{{
                  user.address.state
                }}<br>
                {{ user.address.country }},{{
                  user.address.pinCode
                }}
                <br>
                <!-- {{ phone }} -->
              </p></b-col>

            <b-col
              class="p-0"
              cols="12"
            >
              <validation-provider
                #default="{ errors }"
                name="sample collection date"
                rules="required"
              >
                <b-form-datepicker
                  id="date"
                  v-model="scheduleTime"
                  :value-as-date="true"
                  class="mb-1"
                  placeholder="When did you collect the samples?"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>

            <div class="d-flex justify-content-between my-2 requestPickupButtons">
              <b-button
                class="requestPickupButton mr-1"
                variant="light"
                @click="hide"
              >
                Cancel
              </b-button>
              <b-button
                class="blue requestPickupButton"
                @click="kitpickupSubmit"
              >
                Request a kit pickup
              </b-button>
            </div>
          </div>

        </div>
        <div
          v-else
          class="kitpickup-modal-done m-md-3 m-sm-1"
        >
          <h1 class="done-heading">
            Thank you for requesting a pick-up of your samples.
            We will be in touch shortly!
          </h1>
          <button
            type="button"
            class="btn btn-primary w-50 btn-lg mt-2"
            @click="hide"
          >
            Done
          </button>

        </div>
      </validation-observer>
    </b-modal>
    <b-modal
      v-else
      ref="schedule-pickup"
      class="kitpickup-modal"
      hide-footer
      hide-header
      centered
      :no-close-on-backdrop="!canCloseThankYouPickupPopup"
      @hide="fetchUsersOnClose"
    >
      <header>
        <img
          src="@/assets/images/icons/close-icon.svg"
          alt=""
          class="modal-close-btn mt-1 "
          @click="hide"
        >
      </header>
      <validation-observer ref="kitPickupForm">
        <div
          class="form"
        >
          <div v-if="kitPickupStep === 0">
            <h1 class="mb-2">
              Send us the samples you collected!
            </h1>
            <p class="mb-2">
              Please confirm the address from where you are sending back your samples:
            </p>
            <div
              class="addressAndDateContainer"
            >
              <ValidationObserver ref="phoneidentity">
                <p
                  v-if="!phone"
                  class="text-danger"
                >
                  Add your phone number for proceeding with kit pickup.
                </p>
                <b-row class="px-1">
                  <b-col
                    class="mb-1 px-0 col-md-2"
                    cols="3"
                  >
                    <validation-provider
                      #default="{ errors }"
                      mode="lazy"
                      name="countryPhoneCode"
                      rules="required"
                      :custom-messages="{
                        required: 'Please select your country code',
                      }"
                    >
                      <v-select
                        id="phoneCode"
                        v-model="countryPhoneCode"
                        placeholder="Country Code"
                        autocomplete
                        :options="countries"
                        label="phonecode"
                        :reduce="country => country.phonecode"
                        class="input-fill h-80 "
                        :class="{'onerror':errors.length>0}"
                        :components="{Deselect}"
                      ><template v-slot:option="option">
                        {{ option.isoCode }} ({{ option.phonecode }})
                      </template>
                      </v-select>

                    </validation-provider>
                  </b-col>
                  <b-col class="px-0">
                    <validation-provider
                      #default="{ errors }"
                      name="phone"
                      :rules="{ required: true, regex: countryPhoneCode === '+91' || countryPhoneCode === '+1' ? /^[0-9]{10}$/ : /^\d{9,14}$/ }"
                      mode="lazy"
                    >
                      <b-form-input
                        id="phone"
                        v-model="phone"
                        placeholder="Phone number"
                        class="mb-1 input-fill"
                        type="text"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                </b-row>
              </ValidationObserver>
            </div>

            <div class="addressAndDateContainer">
              <b-col
                class="p-2 mb-2 gray-background"
                cols="12"
              >
                <div class="d-flex justify-content-between">
                  <h4 class="d-flex align-items-end">
                    {{ user.firstName + " " + user.lastName }}
                  </h4>
                </div>
                <p class="text-left mt-2">
                  {{ user.address.street
                  }},{{ user.address.street1 }}<br>
                  {{ user.address.city }},{{
                    user.address.state
                  }}<br>
                  {{ user.address.country }},{{
                    user.address.pinCode
                  }}
                  <br>
                  <!-- {{ phone }} -->
                </p>

                <b-button
                  class="mt-2"
                  variant="link"
                  style="padding:0px"
                  @click="toggleEditDetailsForm"
                >
                  Edit Details
                </b-button>
              </b-col>
              <b-col
                class="p-0"
                cols="12"
              >
                <validation-provider
                  #default="{ errors }"
                  name="sample collection date"
                  rules="required"
                >
                  <b-form-datepicker
                    id="date"
                    v-model="scheduleTime"
                    :value-as-date="true"
                    class="mb-1"
                    placeholder="When did you collect the samples?"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>

              <div class="d-flex justify-content-between my-2 requestPickupButtons">
                <b-button
                  class="requestPickupButton mr-1"
                  variant="light"
                  @click="hide"
                >
                  Cancel
                </b-button>
                <b-button
                  class="blue requestPickupButton"
                  @click="confirmAddress()"
                >
                  Confirm Address
                </b-button>
              </div>
            </div>
          </div>
          <div v-else>
            <h1 class="mb-2">
              How to send us your samples
            </h1>
            <p class="mb-2">
              Please follow the instructions below:
            </p>
            <div class="addressAndDateContainer">
              <b-col
                class="p-2 mb-2 blue-background"
                cols="12"
              >
                <ol class="mt-2">
                  <li class="mb-2">
                    Make sure the collection tubes are securely closed, with the caps fastened tightly. Place the tubes back in the box provided.
                  </li>
                  <li class="mb-2">
                    Place your kit in the pre-labelled shipping pouch and seal the same.
                  </li>
                  <li class="mb-2">
                    Drop your package off at the nearest outgoing USPS mailbox.
                  </li>
                </ol>
              </b-col>

              <div class="d-flex justify-content-between my-2 requestPickupButtons">
                <b-button
                  class="requestPickupButton mr-1"
                  variant="light"
                  @click="kitPickupStep = 0"
                >
                  Go back
                </b-button>
                <b-button
                  class="blue requestPickupButton"
                  @click="kitpickupSubmit"
                >
                  Done
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
    </b-modal>
    <b-modal
      ref="edit-details"
      class="kitpickup-modal"
      hide-footer
      centered
      size="lg"
      :no-close-on-backdrop="!canCloseThankYouPickupPopup"
      @hide="cancelEditDetails()"
    >
      <div class="edit-details">
        <b-row>
          <b-col
            cols="12"
            class="mb-1"
          >
            <h2 class="text-center">
              Edit your details
            </h2>
          </b-col>
          <b-col
            cols="12"
          >
            <p>
              <b>Personal info:</b>
            </p>
          </b-col>
        </b-row>
        <validation-observer ref="editDetailsForm">
          <b-row>
            <b-col
              cols="6"
            >
              <validation-provider
                #default="{ errors }"
                name="firstname"
                rules="required"
              >
                <b-form-input
                  id="firstName"
                  v-model="userModified.firstName"
                  placeholder="First Name"
                  class="mb-1 input-fill"
                  type="text"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                #default="{ errors }"
                name="lastname"
                rules="required"
              >
                <b-form-input
                  id="lastName"
                  v-model="userModified.lastName"
                  placeholder="Last Name"
                  class="mb-1 input-fill"
                  type="text"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <!-- <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="phone"
              rules="required"
            >
              <b-form-input
                id="phone"
                v-model="phone"
                placeholder="Phone number"
                class="mb-1 input-fill"
                type="text"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col> -->
            <b-col
              cols="12"
              class="mt-1"
            >
              <p>
                <b>Address:</b>
              </p>
            </b-col>
            <b-col
              cols="12"
            >
              <validation-provider
                #default="{ errors }"
                name="street"
                rules="required"
              >
                <b-form-input
                  id="adress-street"
                  v-model="userModified.address.street"
                  placeholder="Address"
                  class="mb-1 input-fill"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider
                #default="{ errors }"
                name="street1"
              >
                <b-form-input
                  id="adress-street1"
                  v-model="userModified.address.street1"
                  placeholder="Address line 2"
                  class="mb-1 input-fill"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="address_country"
                rules="required"
              >
                <v-select
                  id="address_country"
                  v-model="userModified.address.country"
                  placeholder="Country"
                  class="mb-1 input-fill"
                  autocomplete
                  :options="countrycode"
                  label="name"
                  disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="state"
                rules="required"
              >
                <v-select
                  id="address-state"
                  v-model="userModified.address.state"
                  placeholder="State"

                  :options="stateOptions"
                  label="name"
                  :reduce="(state) => state.name"
                  class="mb-1 input-fill"
                  @input="resetCity()"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="city"
                rules="required"
              >
                <v-select
                  id="address-city"
                  v-model="userModified.address.city"
                  placeholder="City"

                  :options="cityOptions"
                  label="name"
                  :reduce="(city) => city.name"
                  class="mb-1 input-fill"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="pincode"
                rules="required|integer|min:5|max:6"
              >
                <b-form-input
                  id="name"
                  v-model="userModified.address.pinCode"
                  placeholder="Pin code"
                  class="mb-1 input-fill"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
        <div class="d-flex justify-content-between my-2 editDetailsButtons">
          <b-button
            class="editDetailsButton mr-1"
            variant="light"
            @click="cancelEditDetails"
          >
            Cancel
          </b-button>
          <b-button
            class="blue editDetailsButton"
            @click="saveEditDetails"
          >
            Save Details
          </b-button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import TimelineCard from '@/components/TimelineCard.vue'
import { mapGetters } from 'vuex'
import { State, City, Country } from 'country-state-city'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import HoverButton from '@/components/BackgroundButton.vue'
import Ripple from 'vue-ripple-directive'
import ScienceCard from '@/components/ScienceCard.vue'
import IntroductionSections from '@/components/IntroductionSections.vue'
import FollowupCard from '@/components/FollowupCard.vue'
import KitUserSelector from '@/components/KituserSelectorMobile.vue'
import FactCard from '@/components/FactCard.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    TimelineCard,
    IntroductionSections,
    FollowupCard,
    ScienceCard,
    ValidationObserver,
    ValidationProvider,
    KitUserSelector,
    HoverButton,
    FactCard,
  },
  data() {
    return {
      mandatoryQuestionnaireData: null,
      nutritionPlanBool: false,
      downloadURL: null,
      showFollowUp: null,
      user: {
        firstName: null,
        lastName: null,
        address: null,
      },
      userModified: {
        firstName: null,
        lastName: null,
        address: {
          city: '',
          state: '',
          street: '',
          street1: '',
          country: '',
          pinCode: '',
        },
      },
      phone: null,
      scheduleTime: null,
      countryPhoneCode: 1,
      scheduleDone: false,
      canCloseThankYouPickupPopup: false,
      kitPickupLoading: null,
      countrycode: ['India', 'United States of America'],
      kitPickupStep: 0,
      Deselect: {
        render: createElement => createElement('span', ''),
      },
    }
  },
  computed: {
    ...mapGetters({
      userData: 'auth/GET_USER',
      contextBarcodeId: 'auth/GET_CONTEXT_BARCODE_ID',
      contextBarcode: 'auth/GET_CONTEXT_BARCODE',
      contextKitUserId: 'auth/GET_CONTEXT_KIT_USER_ID',
      contextKitUser: 'auth/GET_CONTEXT_KIT_USER',
      breakpoint: 'app/currentBreakPoint',
    }),
    progressString() {
      if (this.mandatoryQuestionnaireData.kitType === 'covid') {
        return `${(typeof this.mandatoryQuestionnaireData.completedQuestions !== 'undefined' ? this.mandatoryQuestionnaireData.completedQuestions : this.mandatoryQuestionnaireData.questionNumber + 1) || 0}/${(this.mandatoryQuestionnaireData.totalQuestions || 49)}`
      } if (this.mandatoryQuestionnaireData.kitType === 'adult' || this.mandatoryQuestionnaireData.kitType === 'longevity') {
        return `${(typeof this.mandatoryQuestionnaireData.completedQuestions !== 'undefined' ? this.mandatoryQuestionnaireData.completedQuestions : this.mandatoryQuestionnaireData.questionNumber + 1) || 0}/${(this.mandatoryQuestionnaireData.totalQuestions || 36)}`
      }
      return `${(typeof this.mandatoryQuestionnaireData.completedQuestions !== 'undefined' ? this.mandatoryQuestionnaireData.completedQuestions : this.mandatoryQuestionnaireData.questionNumber + 1) || 0}/${(this.mandatoryQuestionnaireData.totalQuestions || 20)}`
    },
    getProgress() {
      return this.mandatoryQuestionnaireData.progress || 0
    },
    colSpan() {
      return this.breakpoint === 'xl' || this.breakpoint === 'lg' ? 6 : 12
    },
    kitPickupEnabled() {
      return !(
        this.contextBarcode.questionnaireStatus !== 'Survey Completed' && this.contextBarcode.kitPickupStatus === 'Not Scheduled'
      )
    },
    countries() {
      // india and us not in this array
      const sortedCountries = Country.getAllCountries().map(coun => ({ isoCode: coun.isoCode, phonecode: coun.phonecode, searchField: coun.isoCode + coun.phonecode })).filter(x => x.isoCode !== 'IN' && x.isoCode !== 'US')
      // contains india and us
      const remainingCountries = Country.getAllCountries().map(coun => ({ isoCode: coun.isoCode, phonecode: coun.phonecode, searchField: coun.isoCode + coun.phonecode })).filter(x => x.isoCode === 'IN' || x.isoCode === 'US').reverse()
      return [...remainingCountries, ...sortedCountries]
    },
    state() {
      let state = 0
      switch (this.contextBarcode.questionnaireStatus) {
        case 'created':
          if (
            Date.now() - Date(this.contextKitUser.metadata[0].value)
            >= 86400
          ) {
            state = 1.5
          }
          break
        case 'Sequencing prep completed':
          state = 3
          break
        case 'Sequencing completed':
          state = 4
          break
        case 'Analyzing sample':
          state = 5
          break
        case 'Reports Ready':
          state = 6
          break
        default:
          break
      }
      if (this.contextBarcode.kitPickupStatus === 'Received') {
        state = 2
      }
      return state
    },
    stateOptions() {
      if (!this.userModified.address.country) return []
      return this.userModified.address.country === this.countrycode[0] ? State.getStatesOfCountry('IN') : State.getStatesOfCountry('US')
    },
    cityOptions() {
      if (!this.userModified.address.state) return []
      return this.userModified.address.country === this.countrycode[0] ? City.getCitiesOfState(
        'IN',
        this.stateOptions.filter(
          state => state.name === this.userModified.address.state,
        )[0].isoCode,
      )
        : City.getCitiesOfState(
          'US',
          this.stateOptions.filter(
            state => state.name === this.userModified.address.state,
          )[0].isoCode,
        )
    },
    kidTimeline() {
      return [
        {
          image: 'img-0',
          computedStatus: 'Your kit has been registered!',
          isActive: true,
        },
        {
          image: 'img-1',
          computedStatus: this.contextBarcode.questionnaireStatus === 'Survey Completed' ? 'Health survey submitted' : 'Please complete your health survey',
          isActive: this.contextBarcode.questionnaireStatus === 'Survey Completed',
          infoIcon: true,
          hoverText: this.contextBarcode.questionnaireStatus !== 'Survey Completed'
            ? 'Please complete this survey to receive your report.'
            : null,
        },
        {
          image: 'img-2',
          computedStatus: this.sampleCollectionStatus(),
          isActive: this.contextBarcode.kitPickupStatus === 'Received' || (this.contextKitUser.address.country === 'India' && this.contextBarcode.kitPickupStatus === 'Scheduled') || this.contextBarcode.userConfirmedKitPickup === true,
        },
        {
          image: 'img-3',
          computedStatus: this.contextBarcode.barcodeStatus === 'Sequencing completed' || this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready' ? 'Sequencing completed' : "We're sequencing your samples",
          isActive: this.contextBarcode.barcodeStatus === 'Sequencing prep completed' || this.contextBarcode.barcodeStatus === 'Sequencing completed' || this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready',
        },
        {
          image: 'img-4',
          computedStatus: this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready' ? 'We are prepping your reports' : "We're analyzing your data",
          isActive: this.contextBarcode.barcodeStatus === 'Sequencing completed' || this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready',
        },
        {
          image: 'img-5',
          computedStatus: 'Your reports are ready!',
          isActive: this.contextBarcode.barcodeStatus === 'Report Ready',
        },
      ]
    },
    adultTimeline() {
      return [
        {
          image: 'img-0',
          computedStatus: 'Your kit has been registered!',
          isActive: true,
        },
        {
          image: 'img-1',
          computedStatus: this.contextBarcode.questionnaireStatus === 'Survey Completed' ? 'Health survey submitted' : 'Please complete your health survey',
          isActive: this.contextBarcode.questionnaireStatus === 'Survey Completed',
          infoIcon: true,
          hoverText: this.contextBarcode.questionnaireStatus !== 'Survey Completed'
            ? 'Please complete this survey to receive your report.'
            : null,
        },
        {
          image: 'img-2',
          computedStatus: this.sampleCollectionStatus(),
          isActive: this.contextBarcode.kitPickupStatus === 'Received' || (this.contextKitUser.address.country === 'India' && this.contextBarcode.kitPickupStatus === 'Scheduled') || this.contextBarcode.userConfirmedKitPickup === true,
        },
        {
          image: 'img-3',
          computedStatus: this.contextBarcode.barcodeStatus === 'Sequencing completed' || this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready' ? 'Sequencing completed' : "We're sequencing your samples",
          isActive: this.contextBarcode.barcodeStatus === 'Sequencing prep completed' || this.contextBarcode.barcodeStatus === 'Sequencing completed' || this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready',
        },
        {
          image: 'img-4',
          computedStatus: this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready' ? 'We are prepping your reports' : "We're analyzing your data",
          isActive: this.contextBarcode.barcodeStatus === 'Sequencing completed' || this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready',
        },
        {
          image: 'img-5',
          computedStatus: 'Your reports are ready!',
          isActive: this.contextBarcode.barcodeStatus === 'Report Ready',
        },
      ]
    },
    covidTimeline() {
      return [
        {
          image: 'img-0',
          computedStatus: 'Your kit has been registered!',
          isActive: true,
        },
        {
          image: 'img-1',
          computedStatus: this.contextBarcode.questionnaireStatus === 'Survey Completed' ? 'Survey completed' : 'Complete your Survey',
          isActive: this.contextBarcode.questionnaireStatus === 'Survey Completed',
          infoIcon: true,
          hoverText: this.contextBarcode.questionnaireStatus !== 'Survey Completed'
            ? 'Please complete this survey to receive your report.'
            : null,
        },
        {
          image: 'img-2',
          computedStatus: this.sampleCollectionStatus(),
          isActive: this.contextBarcode.kitPickupStatus === 'Received' || (this.contextKitUser.address.country === 'India' && this.contextBarcode.kitPickupStatus === 'Scheduled') || this.contextBarcode.userConfirmedKitPickup === true,
        },
        {
          image: 'img-6',
          computedStatus: 'Your starter nutrition plan is ready',
          isActive: this.contextBarcode.barcodeStatus === 'Nutrition plan ready' || this.contextBarcode.barcodeStatus === 'Sequencing completed' || this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready',
        },
        {
          image: 'img-3',
          computedStatus: this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready' ? 'We are prepping your reports' : 'Analysing your samples',
          isActive: this.contextBarcode.barcodeStatus === 'Sequencing completed' || this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready',
        },
        {
          image: 'img-5',
          computedStatus: 'Your reports are ready!',
          isActive: this.contextBarcode.barcodeStatus === 'Report Ready',
        },
      ]
    },
    longevityTimeline() {
      return [
        {
          image: 'img-0',
          computedStatus: 'Your kit has been registered!',
          isActive: true,
        },
        {
          image: 'img-1',
          computedStatus: this.contextBarcode.questionnaireStatus === 'Survey Completed' ? 'Health survey submitted' : 'Please complete your health survey',
          isActive: this.contextBarcode.questionnaireStatus === 'Survey Completed',
          infoIcon: true,
          hoverText: this.contextBarcode.questionnaireStatus !== 'Survey Completed'
            ? 'Please complete this survey to receive your report.'
            : null,
        },
        {
          image: 'img-2',
          computedStatus: this.sampleCollectionStatus(),
          isActive: this.contextBarcode.kitPickupStatus === 'Received' || (this.contextKitUser.address.country === 'India' && this.contextBarcode.kitPickupStatus === 'Scheduled') || this.contextBarcode.userConfirmedKitPickup === true,
        },
        {
          image: 'img-3',
          computedStatus: this.contextBarcode.barcodeStatus === 'Sequencing completed' || this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready' ? 'Sequencing completed' : "We're sequencing your samples",
          isActive: this.contextBarcode.barcodeStatus === 'Sequencing prep completed' || this.contextBarcode.barcodeStatus === 'Sequencing completed' || this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready',
        },
        {
          image: 'img-4',
          computedStatus: this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready' ? 'We are prepping your reports' : "We're analyzing your data",
          isActive: this.contextBarcode.barcodeStatus === 'Sequencing completed' || this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready',
        },
        {
          image: 'img-5',
          computedStatus: 'Your reports are ready!',
          isActive: this.contextBarcode.barcodeStatus === 'Report Ready',
        },
      ]
    },
  },
  watch: {
    contextBarcode: {
      handler(newVal) {
        if (!newVal) return
        if (!newVal.questionnaireResponses) return
        Promise.all([this.$http
          .get(
            `questionnaireResponse/${newVal.questionnaireResponses.mandatory}`,
          ), this.$http
          .get(
            `barcodes/${this.contextBarcodeId}`,
          )])
          .then(resp => {
            this.mandatoryQuestionnaireData = resp[0].data
            this.nutritionPlanBool = resp[1].data.nutritionPlanPublished
            // eslint-disable-next-line prefer-destructuring
            if (this.contextBarcode.kitType === 'covid') {
              this.downloadURL = resp[1].data.reports.starterNutritionPlan
            }
            this.closeLoading()
          })
          .catch(this.handleError)
      },
      deep: true,
      immediate: true,
    },
  },
  beforeMount() {
    this.showLoading('Loading')
    // get data to show followup card
    if (this.contextBarcode.barcodeStatus === 'Reports Ready') {
      this.$http.get(`/barcodes/${this.contextBarcodeId}`).then(({ data }) => {
        const { metadata } = data
        this.showFollowUpCard(metadata)
      })
    }
    // load data for kitpickup request modal
    this.prePopulateAddress()
    this.user.firstName = this.contextKitUser.firstname
    this.user.lastName = this.contextKitUser.lastname
    this.userModified = JSON.parse(JSON.stringify(this.user))
    // Ensure we have the latest kit users and barcode details
    this.$store.dispatch('auth/FETCH_USER').then().catch(() => {
    }).catch(this.handleError)
  },
  mounted() {
    // If there are no kit users for the user, force them to create one
    if (this.userData.kitUsers.length === 0) this.$router.push({ name: 'kit-registration' })
  },
  methods: {
    sampleCollectionStatus() {
      let status
      if (this.contextBarcode.barcodeStatus === 'Sequencing prep completed' || this.contextBarcode.barcodeStatus === 'Sequencing completed' || this.contextBarcode.barcodeStatus === 'Data analysis completed' || this.contextBarcode.barcodeStatus === 'Report Ready') { status = 'DNA extraction completed' } else if (this.contextBarcode.kitPickupStatus === 'Received') { status = "We're collecting and purifying DNA" } else if (this.contextKitUser.address.country === 'India' && this.contextBarcode.kitPickupStatus === 'Scheduled') status = 'Sample collection complete'
      else status = 'Send us your samples'
      return status
    },
    openGuidePdf() {
      if (this.contextBarcode.duBarcode === '' && this.contextBarcode.saBarcode === '') {
        window.open('/assets/pdf/guide-ST.pdf', '_blank')
      } else if (this.contextBarcode.duBarcode === '' && this.contextBarcode.stBarcode === '') {
        window.open('/assets/pdf/guide-SA.pdf', '_blank')
      } else {
        window.open('/assets/pdf/guide.pdf', '_blank')
      }
      // for covid kits
      //  else window.open('/assets/pdf/covid-guide.pdf', '_blank')
    },
    getBlob(link) {
      return new Promise((resolve, reject) => {
        this.$http({
          method: 'GET',
          url: link,
          responseType: 'blob',
        }).then(resp => {
          resolve(window.URL.createObjectURL(resp.data))
        }).catch(err => {
          reject(err)
          this.handleError(err)
        })
      })
    },
    async download() {
      const url = new URL(this.downloadURL)
      const filename = url.pathname.split('/').reverse()[0]
      const starterNtritionPlan = await this.getBlob(this.downloadURL)
      const link = document.createElement('a')
      link.href = starterNtritionPlan
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },
    showFollowUpCard(metadata) {
      const reportsPublishedData = metadata.filter(item => item.key === 'Reports Published')[0]
      // 604800 is the number of seconds in a week
      const reportsPublishedDate = process.env.VUE_APP_BASE_URL === 'https://api.navipointhealth.com/' ? reportsPublishedData.value.at + 4 * 604800 : reportsPublishedData.value.at + 300
      if (Math.floor(Date.now() / 1000) > reportsPublishedDate) { this.showFollowUp = true } else this.showFollowUp = false
    },

    // methods wrt kit pickup requests
    fetchUsersOnClose() {
      this.$store.dispatch('auth/FETCH_USER').catch(this.handleError)
    },
    showKitpickupModal() {
      this.prePopulateAddress()
      this.$refs['schedule-pickup'].show()
    },
    prePopulateAddress() {
      this.user.address = this.contextKitUser.address
      this.countryPhoneCode = this.userData.countryCode ? this.userData.countryCode : 1
      this.phone = this.userData.phone ? this.userData.phone.slice(this.userData.countryCode.length + 1) : null
    },
    hide() {
      this.user.firstName = this.contextKitUser.firstname
      this.user.lastName = this.contextKitUser.lastname
      this.prePopulateAddress()
      this.userModified = JSON.parse(JSON.stringify(this.user))
      this.$refs['schedule-pickup'].hide()
    },
    confirmAddress() {
      this.$refs.kitPickupForm.validate().then(result => {
        if (result === true) {
          this.kitPickupStep = 1
        }
      })
    },
    async editDetails() {
      this.$refs['edit-details'].hide()
    },
    async kitpickupSubmit() {
      this.kitPickupLoading = true
      const scheduleData = {
        barcodeID: this.contextBarcodeId,
        address: this.user.address,
        sampleCollectionDate: this.scheduleTime,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        phone: `+${this.countryPhoneCode}${this.phone}`,
        countryCode: this.countryPhoneCode,
      }
      // (this.address.country)
      // if (this.user.address.country !== 'India') {
      //   delete scheduleData.sampleCollectionDate
      // }
      if (!(await this.$refs.kitPickupForm.validate())) return
      this.$http
        .post('barcodes/schedule', scheduleData, {
          params: {
            country: scheduleData.address.country === 'United States of America' ? 'us' : 'in',
          },
        })
        .then(() => {
          this.scheduleDone = true
          if (scheduleData.address.country === 'United States of America') {
            this.hide()
          }
          // Don't let them close the thank you popup until it's atleast 3 seconds
          setTimeout(() => {
            this.canCloseThankYouPickupPopup = true
          }, 3000)
        })
        .catch(this.handleError)
        .finally(() => {
          this.kitPickupLoading = false
        })
    },
    toggleEditDetailsForm() {
      this.$refs['edit-details'].show()
      // this.prePopulateAddress()
    },
    saveEditDetails() {
      this.$refs.editDetailsForm.validate().then(success => {
        if (success === true) {
          this.user = JSON.parse(JSON.stringify(this.userModified))
          this.$refs['edit-details'].hide()
        }
      })
    },
    cancelEditDetails() {
      this.userModified = JSON.parse(JSON.stringify(this.user))
      this.fetchUsersOnClose()
      this.$refs['edit-details'].hide()
    },
    resetCity() {
      this.userModified.address.city = null
    },

  },
}
</script>
<style lang="scss">
#phoneCode{
.vs__dropdown-menu{
 width: 14rem;
}
}
%card-title {
  text-align: left;
  padding-right: 3.688rem;
  /* font: normal normal normal 24px/32px 'Circular Std'; */
  font-family: "Circular Std";
  font-size: var(--dashboard-title-font-size);
  letter-spacing: 0px;
  color: var(--color-primary-dark);
  opacity: 1;
  font-weight: 400;
  @media only screen and (min-width: 768px) {
    padding-bottom: 3.5rem;
  }
}

.complete-survey-sm {
  color: black;
  padding-left: 0.5rem;

  .survey-pill {
    border: 1px solid #FDE8E7;
    border-radius: 50px;
    background-color: #FFE9E8;
    padding: 0.5rem 1.25rem;
    color: #E85650;
    width: fit-content;

    &::before {
      content: '';
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #E85650;
      margin-right: 0.5rem;
    }
  }
}

.main {
  background: #F7F7F8;
  min-height: initial;
}

.pdf-guide-card {
  border-radius: 10px;
  background-color: white;

  .title {
    @extend %card-title;
    padding: 0;
  }

  #btn {
    width: min-content;
  }

  .subtitle {
    font-size: var(--dashboard-default-font-size);
    color: var(--color-primary-light);
  }
  .learn-more-image{
    height: 180px;
    width:180px;
    align-self:center;
    overflow:hidden;
  }
}

.mandatory-questionnaire-card {
  border-radius: 10px;
  background-color: white;
  position: relative;
  // background-image: url('../../assets/images/dashboard-mandatory-questionnaire.png');
  // background-repeat: no-repeat;
  // background-position: bottom right;
  .covid-product-img{
    display:block;
    max-width:150px;
    position: absolute;
    bottom: 0;
    right: 0;

  }
  .title {
    @extend %card-title;
    padding: 0;
  }
  #btn {
    width: min-content;
  }
  .questions-pending-status {
    text-align: left;
    font-size: var(--dashboard-default-font-size);
    color: var(--color-secondary);
    margin: 0;
    margin-right: 1.438rem;

    .status-count {
      font-weight: 700;
      font-size: var(--dashboard-default-font-size);
    }
  }
}

@media only screen and (max-width: 768px) {
  .mandatory-questionnaire-card {
      .covid-product-img{
        width:150px;
      }
  }

}

.covid-default-report-card {
  border-radius: 0.375rem;
  padding: 1.563rem;
  background-color: #EBF0FF;
  border: solid 0.031rem #E7EFF8;
  margin: 1rem 0.6rem;

  .title {
    @extend %card-title;
  }

  img {
    width: 4.875rem;
    height: 4.875rem;
  }
}

.modal-body{
  padding: 2rem;
}

.done {
  padding: 4rem;

  img {
    margin-bottom: 2.625rem;
    width: 6.625rem;
  }
  .done-h {
    text-align: center;
    font: normal normal medium 2.25rem/3.188rem "Circular Std";
    letter-spacing: 0px;
    color: #141414;
  }
}
  .head {
    width: 100%;

    .heading {
      text-align: left;
      font-family: "Circular Std";
      font-size: 24px;
      letter-spacing: 0px;
      font-weight: 500;
      opacity: 1;
    }

    div {
      display: flex;
      align-items: center;

      #btn {
        color: #e5e5e5;
        display: flex;
        justify-content: center;
        opacity: 1;
        padding: 0.5rem;
        cursor: pointer;
        margin-right: 1.5rem;
        border: 1px solid #e5e5e5;
        border-radius: 1.5rem;
        transition: all 0.2s ease-in-out;

        &.enabled {
          color: #0a6eca;
        }
      }
      }
    }

   #your-next-action {
     span {
       color: var(--color-primary-dark);
       font-size: var(--dashboard-default-font-size);
     }

   button {
     background: #0a6eca !important;
     border: none !important;
   }
  }

  .modal {
  .form {
    margin: 0.5rem;
    h1 {
      text-align: center;
      font: normal normal 600 1.875rem/2.563rem "Circular Std";
      letter-spacing: -0.015em;
      color: var(--color-primary-dark);
      opacity: 1;
    }

    p {
      text-align: center;
      font-size: var(--dashboard-default-font-size);
      color: #4b4b4b;
      opacity: 1;
    }

    label {
      text-align: left;
      font-size: var(--dashboard-default-font-size);
      color: #141414;
      opacity: 1;
      margin-top: 1rem;
      margin-bottom: 1rem;
    }

    .gray-background {
      background: #f7f7f8 0% 0% no-repeat padding-box;
    }

    .blue-background {
      background: #F5F7FC 0% 0% no-repeat padding-box;
    }

    .addressAndDateContainer {
      display: block;
      margin: 0 auto;
      max-width: 100%;
    }

    .blue {
      background: var(--color-primary-dark) 0% 0% no-repeat padding-box !important;
      border: none;
    }

    .requestPickupButtons {
      .requestPickupButton{
        width: 100%;
        padding: 1.5em 1em;
        letter-spacing: 0.015em;
        text-align: center;
        font-family: 'Circular Std';
     }
      }
  }

  .input-fill {
      background: #f5f7fc;
      border: none;
      height: 38px;
    }

  .edit-details{
    margin: 0 auto;
    width: 100%;

    .editDetailsButtons {
      .editDetailsButton{
        width: 100%;
        padding: 1.5em 1em;
        letter-spacing: 0.015em;
        text-align: center;
        font-family: 'Circular Std';
     }

     .blue {
      background: var(--color-primary-dark) 0% 0% no-repeat padding-box !important;
      border: none;
    }
      }
  }
}

.kitpickup-modal-done {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .done-heading {
    text-align: center;
    font: normal normal 500 2rem "Circular Std";
    letter-spacing: 0px;
    color: #142B6F;
    @media (max-width: 768px){
      font-size: 22px;
    }
  }
}

</style>
